module.exports = __webpack_public_path__ + "img/dividend-active.5bca7d10.svg";